var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100px",
  height: "100px",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "providers/ms-teams/icon")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "17.8759148%",
  y1: "-6.51032331%",
  x2: "82.1242061%",
  y2: "106.510437%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A62C3",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D55BD",
  offset: "50%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3940AB",
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "providers/ms-teams/icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7F7F9",
  x: 0,
  y: 0,
  width: 100,
  height: 100
}), /*#__PURE__*/React.createElement("g", {
  id: "Microsoft_Office_Teams_(2018\\u2013present)",
  transform: "translate(18.000000, 20.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.6407461,22.4999928 L61.1721022,22.4999928 C62.7339168,22.4999928 64,23.7759666 64,25.3499822 C64,25.3499822 64,25.3499822 64,25.3499822 L64,40.5254821 C64,46.3103967 59.3467738,50.999974 53.6067009,50.999974 L53.6067009,50.999974 L53.5575703,50.999974 C47.8174973,51.0007842 43.1636107,46.3118726 43.162778,40.526958 C43.162778,40.5264661 43.162778,40.5259741 43.162778,40.5254532 L43.162778,23.9895068 C43.162778,23.1668607 43.8245055,22.4999928 44.6407461,22.4999928 L44.6407461,22.4999928 Z",
  id: "Path",
  fill: "#5059C9"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#5059C9",
  cx: 55.8139618,
  cy: 12.7499863,
  rx: 6.69767542,
  ry: 6.74999783
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#7B83EB",
  cx: 34.9767398,
  cy: 9.75000651,
  rx: 9.67442962,
  ry: 9.75000651
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.8764771,22.4999928 L20.5886399,22.4999928 C19.0454323,22.5384815 17.8246607,23.8291853 17.8604678,25.3845063 L17.8604678,42.6930056 C17.6449649,52.0263498 24.9718341,59.7715853 34.2325728,59.9999928 C43.4933115,59.7715853 50.8201521,52.0263498 50.6046779,42.6930056 L50.6046779,25.3845063 C50.6404275,23.8291853 49.4196847,22.5384815 47.8764771,22.4999928 Z",
  id: "Path",
  fill: "#7B83EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.7209356,22.4999928 L35.7209356,46.754985 C35.7135272,47.8672515 35.044736,48.8664827 34.0241911,49.2899745 C33.699257,49.428505 33.3500303,49.4999928 32.9972142,49.4999928 L19.1702259,49.4999928 C18.976747,49.0049842 18.7981423,48.5099844 18.649286,47.9999928 C18.1282887,46.2787954 17.8624491,44.4895034 17.8604391,42.6899959 L17.8604391,25.3799918 C17.8246607,23.8271595 19.0434223,22.5384815 20.5841604,22.4999928 L35.7209356,22.4999928 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.2325728,22.4999928 L34.2325728,48.2549748 C34.2325728,48.6105471 34.1616478,48.9625019 34.0241911,49.2899745 C33.603982,50.3184919 32.6124963,50.9925367 31.5088515,50.999974 L19.8697704,50.999974 C19.6167375,50.5049741 19.3786075,50.0099743 19.1702259,49.4999928 C18.9618442,48.9899939 18.7981423,48.5099844 18.649286,47.9999928 C18.1282887,46.2788243 17.8624491,44.4895034 17.8604391,42.6899959 L17.8604391,25.3799918 C17.8246607,23.8271595 19.0434223,22.5384815 20.5841604,22.4999928 L34.2325728,22.4999928 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.2325728,22.4999928 L34.2325728,45.2549951 C34.2212306,46.7662711 33.0084129,47.9885633 31.5088515,47.9999928 L18.6493147,47.9999928 C18.1283174,46.2788243 17.8624778,44.4895034 17.8604678,42.6899959 L17.8604678,25.3799918 C17.8246894,23.8271595 19.043451,22.5384815 20.5841891,22.4999928 L34.2325728,22.4999928 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7441814,22.4999928 L32.7441814,45.2549951 C32.7328391,46.7662711 31.5200215,47.9885633 30.02046,47.9999928 L18.6493147,47.9999928 C18.1283174,46.2788243 17.8624778,44.4895034 17.8604678,42.6899959 L17.8604678,25.3799918 C17.8246894,23.8271595 19.043451,22.5384815 20.5841891,22.4999928 L32.7441814,22.4999928 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.7209356,14.7450049 L35.7209356,19.4700034 C35.4679027,19.4849937 35.2297727,19.500013 34.9767398,19.500013 C34.723707,19.500013 34.485577,19.4850227 34.2325441,19.4700034 C33.7301539,19.4364053 33.2318985,19.3560709 32.7441814,19.2300131 C29.7302131,18.5106789 27.2401997,16.3804288 26.046506,13.5000246 C25.8411106,13.0163109 25.6816585,12.5140474 25.5702172,12.0000347 L32.9971855,12.0000347 C34.4991015,12.0057646 35.7152214,13.2313559 35.7209356,14.7450049 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.2325728,16.2449948 L34.2325728,19.4700034 C33.7301826,19.4364053 33.2319272,19.3560709 32.7442101,19.2300131 C29.7302418,18.5106789 27.2402284,16.3804288 26.0465347,13.5000246 L31.5088515,13.5000246 C33.0107388,13.5057545 34.2268586,14.7313747 34.2325728,16.2449948 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.2325728,16.2449948 L34.2325728,19.4700034 C33.7301826,19.4364053 33.2319272,19.3560709 32.7442101,19.2300131 C29.7302418,18.5106789 27.2402284,16.3804288 26.0465347,13.5000246 L31.5088515,13.5000246 C33.0107388,13.5057545 34.2268586,14.7313747 34.2325728,16.2449948 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7441814,16.2449948 L32.7441814,19.2299842 C29.7302131,18.51065 27.2401997,16.3803999 26.046506,13.4999957 L30.02046,13.4999957 C31.5223761,13.5057545 32.7384672,14.7313747 32.7441814,16.2449948 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.7281721,13.4999957 L30.0159806,13.4999957 C31.5227206,13.4999957 32.7441527,14.7309985 32.7441527,16.2494803 L32.7441527,43.7504618 C32.7441527,45.2689726 31.5226919,46.4999465 30.0159806,46.4999465 L2.7281721,46.4999465 C1.22143202,46.4999465 0,45.2689436 0,43.7504618 L0,16.2494803 C0,14.7309985 1.22146074,13.4999957 2.7281721,13.4999957 Z",
  id: "Path",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "23.5520131 23.9669923 18.0971046 23.9669923 18.0971046 38.9369971 14.6217792 38.9369971 14.6217792 23.9669923 9.19219699 23.9669923 9.19219699 21.0630029 23.5520131 21.0630029"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.1093d16a76a97242c3d4041b5f1e0fd9.svg";